import { MineTypeMap } from "../../../../../shared/components/report-form/models/mime-type-map.model";
export function getPropertyFieldCardLink(clickAction) {
    const label = ` <i class="las la-cloud-download-alt la-lg"></i>`;
    const reportLink = {
        text: label,
        address: "",
        clickAction: () => {
            clickAction();
        }
    };
    return reportLink;
}
export function setPublicFieldCardParameters(x, propertyId, moduleId) {
    const model = JSON.parse(x.value[0].metadata);
    model.reportID = x.value[0].id;
    model.moduleId = moduleId;
    model.exportType = "pdf";
    model.uploadReport = false;
    model.canDownloadInPortal = false;
    model.componentType = "view application location pv";
    const propertyDetails = model.reportCriteria.find(z => z.CriteriaName.toLowerCase() == "id");
    propertyDetails.CriteriaFieldValue = propertyId.toString();
    delete propertyDetails.CriteriaDropDown;
    delete propertyDetails.CriteriaDefaultValue;
    delete propertyDetails["CriteriaVisible"];
    const surveyDetails = model.reportCriteria.find(z => z.CriteriaName.toLowerCase() == "surveyurl");
    delete surveyDetails.CriteriaDropDown;
    delete surveyDetails.CriteriaDefaultValue;
    delete surveyDetails["CriteriaVisible"];
    surveyDetails.CriteriaFieldValue = "";
    return model;
}
export function setMunicipalFieldCardParameters(x, propertyId, moduleId) {
    const model = JSON.parse(x.value[0].metadata);
    model.reportID = x.value[0].id;
    model.moduleId = moduleId;
    model.exportType = "pdf";
    model.uploadReport = false;
    model.canDownloadInPortal = false;
    model.componentType = "view application location pv";
    const propertyDetails = model.reportCriteria.find(z => z.CriteriaName.toLowerCase() == "id");
    propertyDetails.CriteriaFieldValue = propertyId.toString();
    delete propertyDetails.CriteriaDropDown;
    delete propertyDetails.CriteriaDefaultValue;
    delete propertyDetails["CriteriaVisible"];
    const surveyDetails = model.reportCriteria.find(z => z.CriteriaName.toLowerCase() == "surveyurl");
    delete surveyDetails.CriteriaDropDown;
    delete surveyDetails.CriteriaDefaultValue;
    delete surveyDetails["CriteriaVisible"];
    surveyDetails.CriteriaFieldValue = "";
    return model;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function handleReportDownload(response, model) {
    const file = new Blob([response], {
        type: MineTypeMap.get(model.exportType).toLocaleLowerCase(),
    });
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL);
}
